var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBaggageclaiminline = function SvgBaggageclaiminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "baggageclaim_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".baggageclaim_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8563_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8571_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8572_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8573_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8574_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8575_",
    d: "M33.7 13.3H29c-.4-1.8-2.1-3.2-4-3.2-2 0-3.6 1.4-4 3.2h-4.5c-1.6 0-2.9 1.2-2.9 2.7v10c0 1.5 1.3 2.7 2.9 2.7h17.3c1.6 0 2.9-1.2 2.9-2.7V16c-.2-1.5-1.5-2.7-3-2.7zM24.9 12c.9 0 1.7.5 2 1.3h-4c.4-.8 1.1-1.3 2-1.3zm9.7 14c0 .4-.4.8-1 .8H16.3c-.5 0-1-.3-1-.8V16c0-.4.4-.8 1-.8h17.3c.5 0 1 .3 1 .8v10z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8579_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8580_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8582_",
    d: "M27.6 20.3v2.3l-1.9-1.9v3.6h-1.5v-3.6l-1.9 1.9v-2.3l2.6-2.6z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8589_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8590_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8591_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8592_",
    d: "M10.6 30.2h28.8v1.9H10.6z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8594_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8595_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8597_",
    d: "M17 36.3c0 1.4-1.2 2.6-2.6 2.6s-2.6-1.2-2.6-2.6 1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8599_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8600_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8601_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8602_",
    d: "M24.1 36.3c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8604_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8605_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8606_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8607_",
    d: "M31.1 36.3c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6c1.5.1 2.6 1.2 2.6 2.6z",
    className: "baggageclaim_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8609_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8610_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baggageclaim_inline_svg__XMLID_8611_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "baggageclaim_inline_svg__XMLID_8612_",
    d: "M38.2 36.3c0 1.4-1.2 2.6-2.6 2.6S33 37.8 33 36.3s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6z",
    className: "baggageclaim_inline_svg__st1"
  }))))))));
};
export default SvgBaggageclaiminline;